import { Outlet } from "react-router-dom";
import ContactList from "./ContactList";
import ContactForm from "./ContactForm";

export const adminContactsRoutes = [
  {
    path: "contacts",
    element: Outlet,
    children: [
      {
        path: "",
        element: ContactList,
      },
      {
        path: "add",
        element: ContactForm,
      },
      {
        path: "edit/:id",
        element: ContactForm,
      },
    ],
  },
];
